import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import {
  FormSelect,
  FormTextAreaField,
  FormFileUpload,
} from '@hvcgroep/design-system';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';


import DataContext from '../../contexts/DataContext';
import './style.scss';
import ValidationFormSchema from '../../components/Form/ValidationFormSchema';
import { MAXIMUM_FILE_SIZE } from '../../config/constants';

const Report = () => {
  const { categories, updateValidationSchema, updateCategoryId, subcategories, updateSubcategories } = useContext(DataContext);
  const { t } = useTranslation();
  const [description, setDescription] = useState();
  const [resetValue, setResetValue] = useState(false);

  useEffect(() => {
    // Update validation schema.
    const subcategorySchemas = subcategories.map((_, i) => {
      return [
        `subject${i + 1}`,
        Yup.string()
          .notOneOf(['default'], t('form.error.required'))
          .required(t('form.error.required')),
      ];
    });

    const schema = Yup.object()
      .shape(Object.fromEntries(subcategorySchemas));

    const newValidationSchema = ValidationFormSchema(t)[1];
    updateValidationSchema(newValidationSchema.concat(schema));
  }, [subcategories]);

  const handleCategoryChange = (evt, categories, index) => {
    const value = evt.nativeEvent.target.value;
    const selectedCategory = categories.find((category) => category.name === value);

    // Set the new category id.
    updateCategoryId(selectedCategory.id);

    // Set the description.
    setDescription(selectedCategory.description);

    // Update the subcategories.
    const newSubcategories = [...subcategories];

    newSubcategories.splice(
      index,
      newSubcategories.length,
      ...(selectedCategory.categories.length > 0 ? [selectedCategory] : []),
    );

    if (newSubcategories.length <= subcategories.length) {
      setResetValue(true);
    }

    updateSubcategories(newSubcategories);
  };

  return (
    <div className="Report">
      <p className="Report--subtitle">{t('reports.stepper.report.subtitle')}</p>
      <FormSelect
        name="subject0"
        label={t('reports.stepper.report.subject')}
        options={categories.map((category) => ({
          value: category.name,
          key: category.name,
        }))}
        placeholder={t('reports.stepper.report.selectSubject.placeholder')}
        resetValue={false}
        onChange={(evt) => handleCategoryChange(evt, categories, 0)}
      />
      {subcategories.length > 0 && subcategories.map(({ id, categories }, i) => (
        <FormSelect
          key={id}
          name={`subject${i + 1}`}
          label={i > 0 ? t('reports.stepper.report.subjectRefineMore') : t('reports.stepper.report.subjectRefine')}
          options={categories.map((category) => ({
            value: category.name,
            key: category.name,
          }))}
          placeholder={t('reports.stepper.report.selectSubject.placeholder')}
          resetValue={resetValue}
          onChange={(evt) => handleCategoryChange(evt, categories, i + 1)}
        />
      ))}
      {description && (
        <WysiwygField
          html={description}
          className="line-break"
        />
      )}
      <FormTextAreaField
        name="description"
        label={t('reports.stepper.report.description.title')}
        placeholder={t('reports.stepper.report.description.placeholder')}
        description={t('reports.stepper.report.description.subtitle')}
      />
      <FormFileUpload
        allowedFileMimes={[
          'image/png',
          'image/jpg',
          'image/jpeg',
        ]}
        buttonText={t('reports.button.uploadPicture')}
        label={t('reports.stepper.report.uploadPicture.title')}
        maxFileCount={3}
        name="images"
        optionalLabel
        allowCamera
      />
    </div>
  );
};

export default Report;
